import Api from './index'
import { API_URL } from '../constants'

class ImportLogs extends Api {
  getImportLogsList(data, params) {
    return this.get('', { data, params })
  }

  getImportLogById(id) {
    return this.get(id)
  }

  getImportLogFileUrl(id) {
    return this.get(`${id}/retrieve_link/`)
  }
}

export default new ImportLogs({
  baseURL: `${API_URL}import_logs/`,
})
